import { defineType } from "sanity";
import { VscTasklist } from "react-icons/vsc";

export default defineType({
  name: "stickyLeadForm",
  title: "Sticky Lead Form",
  type: "object",
  icon: VscTasklist,

  fields: [
    {
      name: "leadGenerationType",
      title: "Lead Generation Type",
      type: "string",
      initialValue: "sfo",
      options: {
        list: [
          { title: "Subscribe to Newsletter", value: "sfo" },
          { title: "Request a Brochure", value: "rab" }
        ]
      },
      validation: (Rule) => Rule.required()
    },
    {
      name: "brochureGroup",
      title: "Brochure Group",
      type: "reference",
      to: [{ type: "brochureGrouping" }],
      hidden: ({ parent }) => parent?.leadGenerationType !== "rab",
      validation: (Rule) =>
        Rule.custom((value, context) => {
          const parent = context.parent as {
            leadGenerationType?: string;
          };
          if (parent?.leadGenerationType === "rab" && !value) {
            return "Brochure Group is required when Lead Generation Type is 'Request a Brochure'";
          }

          return true;
        })
    },
    {
      name: "thumbnail",
      title: "Thumbnail",
      type: "imageWithAlt",
      description: "leave empty for the default value (both for SFO and RAB)",
      options: { hotspot: true }
    },
    {
      name: "customTitle",
      title: "Custom Title",
      type: "multilingualArrayString",
      description: "leave empty for the default value (both for SFO and RAB)",
      options: {
        collapsed: true,
        collapsable: true
      }
    },
    {
      name: "customDescription",
      title: "Custom Description",
      type: "multilingualArrayString",
      description: "leave empty for the default value (both for SFO and RAB)",
      options: {
        collapsed: true,
        collapsable: true
      }
    },
    {
      name: "ctaLabel",
      title: "CTA Label",
      type: "multilingualArrayString",
      description: "leave empty for the default value (both for SFO and RAB)",
      options: {
        collapsed: true,
        collapsable: true
      }
    }
  ],
  preview: {
    select: {
      leadGenerationType: "leadGenerationType"
    },
    prepare({ leadGenerationType }) {
      const map: Record<string, string> = {
        sfo: "SFO",
        rab: "RAB"
      };

      return {
        title: `Sticky Lead Form - ${
          leadGenerationType ? map[leadGenerationType] : "Not set"
        }`
      };
    }
  }
});
